import { render, staticRenderFns } from "./index.vue?vue&type=template&id=155d1ca6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/ipo-subscriptions-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fipo-subscriptions%2Findex.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/ipo-subscriptions-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fipo-subscriptions%2Findex.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,SubscriptionCard: require('/vercel/path0/components/SubscriptionCard.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,VideoThumbnailCard: require('/vercel/path0/components/ui/VideoThumbnailCard.vue').default,AppStoreLinks: require('/vercel/path0/components/blocks/AppStoreLinks.vue').default,CImage: require('/vercel/path0/components/ui/c-image.vue').default,IvestorAppStoreLinks: require('/vercel/path0/components/blocks/ivestorAppStoreLinks.vue').default,HalfMediaHalfGrid: require('/vercel/path0/components/blocks/HalfMediaHalfGrid.vue').default,HalfImageHalfGrid: require('/vercel/path0/components/HalfImageHalfGrid.vue').default,Decorator: require('/vercel/path0/components/ui/decorator.vue').default,FaqsAccordion: require('/vercel/path0/components/datablocks/FaqsAccordion.vue').default})
